import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=58ce70ca"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ce70ca')) {
      api.createRecord('58ce70ca', component.options)
    } else {
      api.reload('58ce70ca', component.options)
    }
    module.hot.accept("./Listado.vue?vue&type=template&id=58ce70ca", function () {
      api.rerender('58ce70ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/Listado.vue"
export default component.exports